import { Injectable } from '@angular/core';
import { Observable, Subject, pipe } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResponseWrapper } from '@library/common/http';

import { Shipment } from '@library/common/models';

import { CacheService } from '@library/core/services';

@Injectable({
   providedIn: 'root'
})
export class ShipmentDetailsService {

   url = 'shipment';

   refresh$: Subject<void> = new Subject();

   constructor( private cache: CacheService ) { }

   load( hawb: any ): Observable<Shipment<any, any>> {
      return this.cache.request<ResponseWrapper<Shipment<any, any>>, Shipment<any, any>>({
         url: this.url + '?hawb=' + hawb,
         refresher: this.refresh$,
         pipe: pipe(
            map( rw => rw.response.collection[0] ),
         ),
         useLambda: true
      });
   }

   resetDetails( hawb: any ) {
      this.cache.clearSet( this.url + '?hawb=' + hawb );
   }

   reset() {
      this.cache.clearSet( this.url );
   }
}
